/**
 * 注册事件监听器，并返回一个可用于移除事件监听的对象。
 *
 * @param {Object} target - 事件监听器要添加到的目标对象。
 * @param {string} eventType - 事件类型，如 'click'、'blur' 等。
 * @param {function} cb - 事件回调函数。
 * @returns {Object} - 可用于移除事件监听的对象，具有一个 `remove` 方法。
 */
export function _registerEvent(target, eventType, cb) {
    const eventListener = target.addEventListener || target.attachEvent;
    eventListener.call(target, eventType, cb);
  
    return {
      remove: function () {
        const eventRemover = target.removeEventListener || target.detachEvent;
        eventRemover.call(target, eventType, cb);
      },
    };
  }
  
  /**
   * 在打开指定URI之前设置一个超时，以处理超时情况。
   *
   * @param {string} uri - 要打开的URI。
   * @param {function} failCb - 超时或失败时的回调函数。
   * @param {function} successCb - 成功时的回调函数。
   * @param {number} timeoutDuration - 超时时长（毫秒）。
   */
  export function openUriWithTimeoutHack(uri, failCb, successCb, timeoutDuration) {
    let timeout = setTimeout(function () {
      failCb();
      handler.remove();
    }, timeoutDuration);
  
    let target = window;
    while (target !== target.parent) {
      target = target.parent;
    }
  
    let handler = _registerEvent(target, 'blur', onBlur);
  
    function onBlur() {
      clearTimeout(timeout);
      handler.remove();
      successCb();
    }
  
    window.location = uri;
  }



 